/* global d3, $ */

var grid = require('./d3grid');

import { graphScroll } from './graph-scroll.js';
import { getGraphWidth, graphTransition, updateLabels } from './gridUtils.js';
import { graphModalPopup, graphModalClose, getModalNavOptions, selectRect } from './gridModal.js';
import getCSVData from '../utils/getCSVData';

const articleContainer = d3.select('#container__one');
const sectionContainer = d3.select('#sections');
const chartContainer = d3.select('#chart-container');
const $graphModal = $('#graph__modal');
const $graphSortBtns = $('.graph__sort--btn');

export default function renderChart () {
  getCSVData('assets/data/data.csv', function (error, data) {
    if (error) throw error;

    var width,
        height,
        browserHeight = window.innerHeight || document.documentElement.clientHeight,
        containerWidth = parseInt(articleContainer.style('width'), 10),
        sectionColumnWidth = parseInt(sectionContainer.style('width'), 10),
        gridShapeSize,
        gridMultiplier,
        gridGutter = 2,
        activeSlug,
        bp = 765;

    // Set chart width and height based on browser window size
    width = getGraphWidth(containerWidth, sectionColumnWidth, bp);

    // Set shape size based on browser width & height
    if (containerWidth < 586 || browserHeight < 500) {
      gridShapeSize = 6;
      gridMultiplier = 6;
    } else if (containerWidth < 586 || browserHeight < 579) {
      gridShapeSize = 10;
      gridMultiplier = 4;
    } else if (containerWidth < 850 || browserHeight < 720) {
      gridShapeSize = 14;
      gridMultiplier = 3;
    } else {
      gridShapeSize = 20;
      gridMultiplier = 3;
    }

    $graphModal.height(browserHeight);

    // Map the data to key values in an array
    data = data.map( function (d, i) {
      return {
        first_name: d.first_name,
        last_name: d.last_name,
        name_slug: d.name_slug,
        crime: d.crime,
        dutystation_city: d.dutystation_city,
        dutystation_state: d.dutystation_state,
        state: d.state,
        service: d.service,
        yearsservice: d.years_of_service,
        prison: d.prison,
        prisontime: d.prison_time_yrs,
        prisontimemonths: d.prison_time_remaindermonths,
        photo: d.photo,
        photo_status: d.photo_status,
        nar: d.narrative,
        index: i,
        color: 'rgb(255, 107, 89)',
        shape: 'square',
        size: gridShapeSize
      };
    });

    chartContainer.select('svg').remove();

    var svg = chartContainer.append('svg')
        .attr('width', width)
        .attr('height', height)
        .attr('class', 'graph__body');

    var shapes = svg.selectAll('.shape')
      .data(data).enter()
        .append('g')
          .attr('data-size', function (d) { return d.size; })
          .attr('data-shape', function (d) { return d.shape; })
          .attr('data-slug', function(d) { return d.name_slug; })
          .attr('class', 'graph__person');

    shapes.append('rect')
      .attr('width', function (d) { return d.size; })
      .attr('height', function (d) { return d.size; });

    shapes.append('svg:image')
      .attr('xlink:href',CONFIG.projectPath + 'assets/images/TT-BSP-part2-corruption-avatar-slate-block.svg')
      .attr('class', 'graph__person--img')
      .attr('width', function (d) { return d.size; })
      .attr('height', function (d) { return d.size; });

    shapes.on('click', function(d) {
      if (window.innerWidth > bp ) {
        activeSlug = d.name_slug;
        graphModalPopup(activeSlug, d, svg, grid, $graphModal);
      }
    });

    // Close Modal
    $('#graph__modal--close').click(function() {
      graphModalClose(svg, $graphModal);
    })

    $('.name__highlight, #graph__modal--prev, #graph__modal--next').off().click(function() {
      activeSlug = $(this).attr('data-name');

      var g = selectRect(activeSlug, svg),
          d = g.datum();

      graphModalPopup(activeSlug, d, svg, grid, $graphModal);

      $('.graph__modal--lightbox').animate({ scrollTop: 0 }, 500);
    });

    $('.name__highlight').hover(function() {
      if (window.innerWidth > bp ) {
        var slug = $(this).attr('data-name');

        selectRect(slug, svg);
      }
    });

    grid = d3.layout.grid()
      .colWidth(gridShapeSize + gridGutter) // width between units
      .rowHeight(gridShapeSize + gridGutter) // height between rows
      .marginTop(20)
      .marginLeft(0)
      .sectionPadding(gridShapeSize * gridMultiplier) // padding between groups
      .width(width)
      .data(data);

    function callGroupBy(group, $clicked) {
      // group by the given data field
      grid.groupBy(group);
      // // update chart labels
      updateLabels(grid, svg, group);
      // transition shapes
      graphTransition(grid, svg, shapes);

      if (!$clicked) $clicked = $graphSortBtns.filter(`[data-group=${group}]`);

      toggleButtons($graphSortBtns, $clicked);

      if($graphModal.hasClass('open')) {
        getModalNavOptions(activeSlug, grid);
      }
    }

    $graphSortBtns.click(function (e) {
      var $clicked = $(e.target);
      var group = $clicked.data('group');

      callGroupBy(group, $clicked);
    });

    const groupings = $graphSortBtns.map((idx, el) => $(el).data('group'));

    var graphSections = d3.selectAll('#sections > div.graph__section');

    var gs;

    if (containerWidth > bp) {
      gs = graphScroll()
        .container(d3.select('#container__one'))
        .graph(d3.selectAll('#graph__one'))
        .sections(graphSections)
        .on('active', function(i) {
            var pos = groupings[i];
            if (i < graphSections.size()) {
              callGroupBy(pos);
            }
          })
    } else {
      $graphSortBtns.first().click();
    }

  });
}

function toggleButtons($buttonList, $activeButton) {
  $buttonList.removeClass('graph__sort--active');
  $activeButton.addClass('graph__sort--active');
}



/** WEBPACK FOOTER **
 ** ./includes/gridChart.js
 **/